<template>
  <div class="share-obituary-comment-edit">
    <h3 v-text="texts.shareCommentEdit.editYourCondolence" />

    <p v-text="texts.shareCommentEdit.editYourCondolenceInfo" />
    <p v-text="texts.shareCommentEdit.editYourCondolenceWarning" />

    <div class="share-obituary-comment__button-group">
      <button class="btn outline" @click.prevent="editComment">
        <svg class="icon"><use href="#pen" /></svg>
        {{ texts.common.edit }}
      </button>

      <button class="btn icon small" @click.prevent="deleteComment">
        <svg class="icon"><use href="#trash" /></svg>
        {{ texts.common.delete }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareCommentEditContent',

  props: {
    changeModalContext: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      texts: lavendlaObituary,
    };
  },

  methods: {
    editComment() {
      if (!this.changeModalContext) {
        return;
      }

      this.changeModalContext('edit');
    },

    deleteComment() {
      if (!this.changeModalContext) {
        return;
      }

      this.changeModalContext('delete');
    },
  },
};
</script>
